export default "__VITE_ASSET__39727279__"